<template>
    <div class="text-primary-500 mr-2 block cursor-pointer" @click="goBack">&#8592; Go Back</div>
</template>

<script>
    export default {
        methods: {
            goBack() {
                if (window.history.length > 2) {
                    this.$router.go(-1);
                } else {
                    this.$router.push('/')
                }
            }
        }
    }
</script>
